module.exports = __webpack_public_path__ + "static/media/vibration.6ddade70.wav";